// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__VpGJb","productName":"Table_productName__Kj6mV"};